// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7ee86248","977":"72fb5178"}[chunkId] + ".chunk.js";
};